<form [formGroup]="outrosContatosForm" id="outrosContatosForm" #formElement (ngSubmit)="salvar()">
  <div class="row row-cols-4 g-3">

    <!-- <div class="col-12 form-group mb-3">
      <label for="escolherContato" class="form-label required">Selecione um contato existente</label>
      <nz-select formControlName="escolherContato" nzShowSearch nzAllowClear
        nzPlaceHolder="Selecionar contato existente" nzSize="large" [compareWith]="compareFn">
        <nz-option [nzValue]="item" [nzLabel]="item?.nomeTipoContato"
          *ngFor="let item of tipoContatoList"></nz-option>
      </nz-select>
    </div>

    <nz-divider></nz-divider> -->

    <div class="col form-group">
      <label for="tipoContato" class="form-label required">Tipo de Contato</label>
      <nz-select formControlName="tipoContato" (ngModelChange)="onTipoContatoChange($event)" nzShowSearch nzAllowClear
        nzPlaceHolder="Tipo de Contato" nzSize="large" [compareWith]="compareFn">
        <nz-option [nzValue]="item" [nzLabel]="item?.nomeTipoContato" *ngFor="let item of tipoContatoList"></nz-option>
      </nz-select>
    </div>

    <ng-container *ngIf="tipoContatoId == tipoContatoEnum.OUTROS">
      <div class="col form-group">
        <label for="areaAtuacao" class="form-label required">Área de Atuação</label>
        <nz-select formControlName="areaAtuacao" nzShowSearch nzAllowClear nzPlaceHolder="Área de Atuação" nzSize="large"
          [compareWith]="compareFn">
          <nz-option [nzValue]="item" [nzLabel]="item.nomeAreaAtuacao" *ngFor="let item of areaAtuacaoList" />
        </nz-select>
      </div>
    </ng-container>

    <ng-container [ngSwitch]="tipoContatoId">
      <ng-container *ngSwitchCase="tipoContatoEnum.ENDERECO">
        <div class="col form-group">
          <label for="pais" class="form-label" [class.required]="tipoContatoId == tipoContatoEnum.ENDERECO">País</label>
          <nz-select formControlName="pais" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
            [compareWith]="compareFn">
            <nz-option [nzValue]="item" [nzLabel]="item.nome" *ngFor="let item of paisesList" />
          </nz-select>
        </div>
        <div class="col form-group" *ngIf="!cepToZipCode">
          <label for="enderecoCep" class="form-label" [class.required]="tipoContatoId == tipoContatoEnum.ENDERECO">CEP</label>
          <nz-input-group nzSize="large">
            <input nz-input id="enderecoCep" formControlName="enderecoCep" placeholder="CEP" mask="00000-000" [ngModel]="cep"
              (ngModelChange)="cep = $event" (focusout)="onCepBlur()" />
          </nz-input-group>
        </div>
        <div class="col form-group">
          <label for="enderecoUf" class="form-label" [class.required]="tipoContatoId == tipoContatoEnum.ENDERECO">Estado</label>
          <nz-select formControlName="enderecoUf" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
            [compareWith]="compareFn">
            <nz-option [nzValue]="item" [nzLabel]="item.nome" *ngFor="let item of ufList" />
          </nz-select>
        </div>
        <div class="col form-group">
          <label for="enderecoMunicipio" class="form-label"
            [class.required]="tipoContatoId == tipoContatoEnum.ENDERECO">Cidade</label>
          <nz-select formControlName="enderecoMunicipio" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
            [compareWith]="compareFn" [maxlength]="150">
            <nz-option [nzValue]="item" [nzLabel]="item.nome" *ngFor="let item of cidadeList" />
          </nz-select>
        </div>
        <div class="col form-group">
          <label for="enderecoBairro" class="form-label"
            [class.required]="tipoContatoId == tipoContatoEnum.ENDERECO">Bairro</label>
          <nz-input-group nzSize="large">
            <input nz-input id="enderecoBairro" formControlName="enderecoBairro" placeholder="Bairro" [maxlength]="150" />
          </nz-input-group>
        </div>
        <div class="col form-group">
          <label for="enderecoLogradouro" class="form-label"
            [class.required]="tipoContatoId == tipoContatoEnum.ENDERECO">Logradouro</label>
          <nz-input-group nzSize="large">
            <input nz-input id="enderecoLogradouro" formControlName="enderecoLogradouro" placeholder="Logradouro" nzSearch [maxlength]="150" />
          </nz-input-group>
        </div>
        <div class="col form-group">
          <label for="enderecoNumero" class="form-label">Número</label>
          <nz-input-group nzSize="large">
            <input nz-input id="enderecoNumero" formControlName="enderecoNumero" placeholder="Número" nzSearch [maxlength]="50" />
          </nz-input-group>
        </div>
        <div class="col form-group">
          <label for="enderecoComplemento" class="form-label">Complemento</label>
          <nz-input-group nzSize="large">
            <input nz-input id="enderecoComplemento" formControlName="enderecoComplemento" placeholder="Complemento" nzSearch [maxlength]="255" />
          </nz-input-group>
        </div>
        <div class="col form-group" *ngIf="cepToZipCode">
          <label for="enderecoCep" class="form-label" [class.required]="tipoContatoId == tipoContatoEnum.ENDERECO">ZIP
            CODE</label>
          <nz-input-group nzSize="large">
            <input nz-input id="enderecoCep" formControlName="enderecoCep" placeholder="ZIP CODE" mask="00000-0000" />
          </nz-input-group>
        </div>
        <div class="col-12 form-group" *ngIf="paginaEntidade">
          <label for="siteUrl" class="form-label">Site</label>
          <nz-input-group nzSize="large">
            <input nz-input formControlName="siteUrl" placeholder="Url Site" />
          </nz-input-group>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="tipoContatoEnum.AREA_ATUACAO">
        <div class="col form-group">
          <label for="areaAtuacao" class="form-label">Área de Atuação</label>
          <nz-select formControlName="areaAtuacao" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
            [compareWith]="compareFn">
            <nz-option [nzValue]="item" [nzLabel]="item.nomeAreaAtuacao" *ngFor="let item of areaAtuacaoList" />
          </nz-select>
        </div>
        <ng-template [ngTemplateOutlet]="default" [ngTemplateOutletContext]="{ select: true }"></ng-template>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ng-template [ngTemplateOutlet]="default"></ng-template>
      </ng-container>
    </ng-container>
  </div>

  <ng-template #default let-data="select">
    <div class="col-12 form-group" [ngClass]="data ? 'col-sm-6' : 'col-sm-5'">
      <label for="nomeContato" class="form-label">Nome do Contato</label>
      <nz-input-group nzSize="large">
        <input nz-input id="nomeContato" formControlName="nomeContato" placeholder="Nome do Contato" [maxlength]="200" />
      </nz-input-group>
    </div>
    <div class="col-sm-2 form-group">
      <label for="ddi" class="form-label">DDI</label>
      <nz-select formControlName="ddi" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
        [compareWith]="compareDdi">
        <nz-option *ngFor="let item of ddiList" [nzValue]="item.ddi" [nzLabel]="item.nome + ' ' + (item.ddi)"></nz-option>
      </nz-select>
    </div>

    <div class="col-sm-2 form-group">
      <label for="telefone" class="form-label"
        [class.required]="tipoContatoId == tipoContatoEnum.TELEFONE">Telefone</label>
      <nz-input-group nzSize="large">
        <input nz-input formControlName="telefone" placeholder="(xx) xxxx-xxxx"
          mask="(00) 0000-0000 || (00) 0 0000-0000" />
      </nz-input-group>
    </div>
    <div class="form-group" [ngClass]="data ? 'col-sm-8' : 'col-sm-6'">
      <label for="telefoneAdicional" class="form-label">Outros Telefones</label>
      <nz-input-group nzSize="large">
        <input nz-input id="telefoneAdicional" formControlName="telefoneAdicional" placeholder="Outros Telefones" />
      </nz-input-group>
    </div>
    <div class="col form-group" [ngClass]="data ? 'col-sm-12' : 'col-sm-6'">
      <label for="email" class="form-label"
        [class.required]="tipoContatoId == tipoContatoEnum.EMAIL || tipoContatoId == tipoContatoEnum.EMAILAREAJURIDICA">E-mail</label>
      <app-email-search-select formControlName="email" placeholder="E-mail"></app-email-search-select>
      <div
        *ngIf="outrosContatosForm.get('email')?.invalid && (outrosContatosForm.get('email')?.dirty || outrosContatosForm.get('email')?.touched)">
        <div *ngIf="outrosContatosForm.get('email')?.errors?.['required']" class="text-danger">E-mail é obrigatório.</div>
      </div>
    </div>
    <div class="col-12 form-group">
      <label for="observacao" class="form-label">Observações</label>
      <nz-input-group nzSize="large">
        <input nz-input id="observacao" formControlName="observacao" placeholder="Observações" [maxlength]="255" />
      </nz-input-group>
    </div>
  </ng-template>
</form>
<div class="row mt-4">
  <div class="col-12 d-flex justify-content-end">
    <button nz-button nzType="default" class="me-3" type="button" (click)="reset()">Limpar</button>
    <button nz-button nzType="primary" type="submit" form="outrosContatosForm">{{ inserir ? 'Adicionar' : 'Editar'
      }}</button>
  </div>
</div>
